export const TOGGLE_MESSAGE_PANEL = 'UI:TOGGLE_MESSAGE_PANEL';
export const SHOW_MESSAGE_PANEL = 'UI:SHOW_MESSAGE_PANEL';
export const HIDE_MESSAGE_PANEL = 'UI:HIDE_MESSAGE_PANEL';
export const SET_NEW_MESSAGE_COUNT = 'UI:SET_NEW_MESSAGE_COUNT';
